module.exports = __webpack_public_path__ + "static/media/pharmacy-store.e4badc8a.jpg";